// extracted by mini-css-extract-plugin
export default {"contacts":"Documents_contacts__4yHLN","text":"Documents_text__Ld1Fi"};